<template>
  <!-- 逾期未取：已取出 -->
  <div class="overdueGet">
    <div class="search">
      <div class="dataTime">
          <!-- <van-search
            v-model="searchIdNoValue"
            placeholder="请输入身份证号查询"
            @input="queryInfo"
            @search="queryInfo"
          >
          </van-search> -->
          <van-search
            v-model="searchPlateNoValue"
            placeholder="请输入车牌号码查询"
            @input="queryInfo"
            @search="queryInfo"
          >
          </van-search>
          <span style="color: #fa8f04;font-weight: bold; font-size: 13px;float: right;margin-right: 5%;">{{ queryDataLength }}</span>
        <van-row>
          <van-cell title="查询开始时间：" is-link :value="dataForm.dateBegin" @click="clickBegin(dataForm.dateBegin)" />
          <van-calendar ref="overdueAlreadyGet" :value="dataForm.dateBegin" v-model="showBegin" :min-date="minDate" :max-date="maxDate" @confirm="onConfirmBegin" />
        </van-row>
        <van-row>
          <van-cell title="查询结束时间：" is-link :value="dataForm.dateEnd" @click="showEnd = true" />
          <van-calendar v-model="showEnd" :min-date="minDate" :max-date="maxDate" @confirm="onConfirmEnd" />
        </van-row>
        <van-divider style="margin: 0;" />
      </div>
    </div>
    <div class="searchContent">
      <van-list
        :finished="finished"
        finished-text="没有更多了"
      >
        <van-cell v-for="item in queryDataArray" :key="item.id" >
          <van-row>
            <van-col :span="18">
              <van-row>
                <van-col :span="8" style="text-align: right;">车牌号码：</van-col>
                <van-col :span="16">{{ item.plateNo }}</van-col>
              </van-row>
              <van-row>
                <van-col :span="8" style="text-align: right;">身份证号：</van-col>
                <van-col :span="16">{{ item.idNo }}</van-col>
              </van-row>
            </van-col>
            <van-col :span="5">
               <van-button  style="height: 42px;" plain hairline type="info" @click="showDetail(item)"
               >{{ '查看' }}</van-button>
            </van-col>
          </van-row>
        </van-cell>
      </van-list>
    </div>
    <!-- 查看详情信息 -->
        <van-overlay :show="showDataDetail" @click="showDataDetail=false">
          <div class="wrapper" @click.stop>
            <div class="applyBlock">
              <van-form>
                <div class="title">
                <!-- <span>{{ showList.state == 0?'编辑信息':'查看信息' }} -->
                  <span>{{ '查看信息' }}
                  <van-icon name="close" class="cancel" @click="cancelForm"/>
                </span>
              </div>
              <van-field label="身份证号："  v-model="showList.idNo" disabled :maxlength="18"/>
              <van-field label="存放位置：" v-model="showList.boxCode" disabled/>
              <van-field label="车牌号码：" v-model="showList.plateNo" disabled :maxlength="8">
              </van-field>
              <van-field label="申请电话：" v-model="showList.applyPhoneNo" disabled />
              <van-field label="创建时间： " v-model="showList.createTime" disabled/>
              </van-form>
              <div style="margin: 16px;">
                  <van-button round block type="info" @click="confirmFrom(showList)" style="margin-top: 10px;">
                    确 定</van-button>
              </div>
            </div>
          </div>
        </van-overlay>

  </div>
</template>

<script>
import {QueryHistory} from '@/my_js//HttpRequest.js'
import {formatTime,getNowTime,formatDateTime,formatBeginTime,formatEndTime} from '@/utils/date.js'
import { Notify,Dialog } from 'vant'
import PlateNumber from '../plateNo.vue'
export default {
  // mounted(){
  //   this.echartsInit()
  // },
  components:{
    PlateNumber,
  },
  filters:{
    formatTime:function(inputTime){
     return formatTime(inputTime)
    }
  },
 
  data(){
    return{
      dataForm:{
        id:'',
        applyState:-1,//申请状态
        plateType:-1,//车牌类型
        plateNo:'',//车牌号
        // idNo:'450881200010108922',
        idNo:'',//身份证号
        phoneNo:'',//手机号
        verifyNo:'',//验证码
        userPhoneNo:'',//管理员手机号
        dateBegin:null,//开始时间
        dateEnd:null,//结束时间
      },
      // exitDisable:false,//编辑按钮禁用
      isPlateNo:false,//是否为车牌号
      radio:'1',//1：身份证号查询，2：车牌号查询
      searchIdNoValue:'',//身份证号搜索内容
      searchPlateNoValue:'',//车牌号搜索内容
      // list:[],
      loading:false,
      loadingImg:false,
      finished:false,
      responseDataArray:[],//响应数据
      queryDataArray:[],//查询数据
      showDataDetail:false,//详情显示
      showList:[],//详情信息列表
      confirmShow:false,//修改确认
      // userName:'',//用户名
      confirmForm:{
        userPhoneNo:'',//身份证号
        userName:'',//用户名
      },
      showBegin:false,
      showEnd:false,
      minDate:new Date(2020,0,1),
      maxDate:new Date(2050,12,31),
      show:false,//是否显示图片
      imgSrc:null,//图片 base64 字符串
      zoom:1,
      queryDataLength:null,//查询到的数据量
      
    }
  },
  mounted(){
    const end = new Date()
    const start = new Date()
    end.setTime(start.getTime() - 3600 * 1000 * 24 * 7)//默认查询7天时间
    const data = formatDateTime(end)
    console.log(data);
    this.dataForm.dateBegin = data
    this.dataForm.dateEnd = getNowTime()//当天时间
    this.onSearch()

  },
  methods:{
    // 返回
    goBack(){
      console.log('返回管理员首页');
      this.$router.push('/manager')
    },
    // 搜索
    onSearch(val){
      this.loading = true
      console.log('搜索输入内容：',val);
      const beginTime = formatBeginTime(this.dataForm.dateBegin)
      const endTime = formatEndTime(this.dataForm.dateEnd)
      const dataArray = {
        plateNo:'',//车牌号
        idNo:'',//身份证号
        operateType:4,
        dateBegin:beginTime,//开始时间
        dateEnd:endTime,//结束时间
      }
      console.log('dataArray:',dataArray);
      QueryHistory(dataArray).then(res =>{
          console.log(res);
          this.responseDataArray = res.data
          this.queryDataArray = this.responseDataArray
          console.log( 'this.responseDataArray',this.responseDataArray);
          this.finished = true
          this.loading=false
        })

      
    },
    // 查询数据
    queryInfo(){
      // 将输入的身份证号和车牌号转换为大写
      const formattedIdNo = this.trimmedStr(this.searchIdNoValue).toUpperCase();
      const formattedPlateNo = this.trimmedStr(this.searchPlateNoValue).toUpperCase();
      console.log('formattedIdNo',formattedIdNo);
      console.log('formattedPlateNo',formattedPlateNo);
      
      
      
      // 优先按照身份证号进行查询
     if (formattedIdNo) {
        this.queryByIdNo(formattedIdNo);
      } else if (formattedPlateNo) {
        this.queryByPlateNo(formattedPlateNo);
      } else{
        console.log('请输入搜索条件');
        this.onSearch()
      }

    },
    // 身份证号查询
    queryByIdNo(idNo){
       // 根据身份证号查询逻辑
      //  debugger
        const filteredData = this.responseDataArray.filter(item =>
          item.idNo.includes(idNo)
        );
        console.log('身份证号查询结果:', filteredData);
        // this.queryDataArray = filteredData

        if(filteredData.length != 0){
        this.queryDataArray = filteredData
        console.log('filteredData',this.filteredData);
      }else{
        this.queryDataArray = filteredData
        Notify({message:'该身份证号暂无信息，请稍后再查询',type:'warning'})
      }
    },
     // 车牌号查询
     queryByPlateNo(plateNo){
      // 根据车牌号查询逻辑
      const filteredData = this.responseDataArray.filter(item =>
        item.plateNo.includes(plateNo)
      );
      console.log('车牌号查询结果:', filteredData);
      
      if(filteredData.length != 0){
        this.queryDataArray = filteredData
        this.queryDataLength = this.queryDataArray.length
        console.log('filteredData',this.filteredData);
      }else{
        this.queryDataArray = filteredData
        Notify({message:'暂无该车牌号信息，请稍后再查询',type:'warning'})
        this.queryDataLength = null
      }
     },
    // 去除空格
    trimmedStr(str){
      return str.replace(/\s+/g,'')
    },
    // 编辑
    showDetail(val){
      console.log('val',val);
      this.showDataDetail = true
      val.createTime = formatTime(val.createTime)
      this.showList = val
    },
     // 获取车牌号
    getPlateNo(data){
        this.showList.plateNo = data
    },
    // 关闭编辑页面
    cancelForm(){
      // 清空搜索信息
      this.searchIdNoValue = ''
      this.searchPlateNoValue = ''
      this.onSearch()
      this.showDataDetail = false
    },
    // 查看数据
    confirmFrom(val){
      // debugger
      console.log(val);
     
      this.showDataDetail = false
      // 清空搜索信息
      this.searchIdNoValue = ''
      this.searchPlateNoValue = ''
      this.onSearch()
      
    },
    // 选择日期并格式化时间
    onConfirmBegin(date){
      this.showBegin = false
      // 格式化时间
      this.dataForm.dateBegin = formatDateTime(date)
      console.log('开始时间：',this.dataForm.dateBegin);
      this.onSearch()
    },
    // 开始时间定位到 dateBegin
    clickBegin(date){
      this.showBegin = true
      this.$nextTick(() => {
        this.$refs.overdueAlreadyGet.reset(new Date(date))// 确保日历定位到指定时间
      })
    },
    // 选择日期并格式化时间
    onConfirmEnd(date){
    this.showEnd = false
    // 格式化时间
    this.dataForm.dateEnd = formatDateTime(date)
    console.log('结束时间：',this.dataForm.dateEnd);
    this.onSearch()
    },

   
  }

}
</script>

<style lang="scss" >
.overdueGet{
  .dataTime{
    .search{
      // .radio{
      //   margin-top: 2%;
      //   font-size: 15px;
      //   display: flex;
      //   // justify-content: center;
      //   justify-content: space-around;
      // }
    }
  }
  .searchContent{
    .van-cell__title{
      line-height: 45px;
    }
  }

  .van-nav-bar__left{
    left: 0;
  }
  .van-nav-bar .van-icon{
    color: #0283ef;
  }
  .van-nav-bar__text{
    color: #0283ef;
  }
  .van-search__action{
    color: #0283ef;
    font-size: 18px;
  }

  .wrapper{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .title{
    margin-top: 3%;
    .cancel{
      float: right;
      margin-right: 3%;
      font-size: 28px;
    }
  }
  .applyBlock{
    width: 95%;
    // height: 68%;
    border-radius: 8px;
    background-color: #fff;
    .van-cell__value{
      text-align: left;
    }
    .van-field__control{
      width: 90%;
    }
  }
  .picWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

.picBlock {
  width: 120px;
  height: 120px;
  background-color: #fff;
}

}

</style>